import SessionAnnotation from './SessionAnnotation';

export default SessionAnnotation;
